<template>
  <div>
    <b-row>
      <b-col>
        <h5 class="text-secondary">{{ $t("globals.current") }}:</h5>
        <hr />
      </b-col>
      <b-col>
        <h5 class="text-secondary">{{ $t("globals.past") }}:</h5>
        <hr />
      </b-col>
      <b-col cols="1">
        <div @click.prevent="fetchData">
          <icon name="sync-alt" :spin="isLoading"></icon>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <!-- Present -->
      <b-col>
        <ulu-parking-row
          :title="$t('globals.no_parkings')"
          :loading="loading.current"
          :int_value="current.no_parkings"
        />
        <ulu-parking-row
          :title="$t('globals.parkings_value')"
          :loading="loading.current"
          :price_value="current.total_parking_costs_no_fees"
        />
        <ulu-parking-row
          :title="$t('globals.no_fees')"
          :loading="loading.current"
          :int_value="current.no_fees"
        />
        <ulu-parking-row
          :title="$t('globals.fees_value')"
          :loading="loading.current"
          :price_value="current.total_fees_value"
        />
      </b-col>
      <!-- Past -->
      <b-col>
        <ulu-parking-row
          :title="$t('globals.no_parkings')"
          :loading="loading.past"
          :int_value="past.no_parkings"
        />
        <ulu-parking-row
          :title="$t('globals.parkings_value')"
          :loading="loading.past"
          :price_value="past.total_parking_costs_no_fees"
        />
        <ulu-parking-row
          :title="$t('globals.no_fees')"
          :loading="loading.past"
          :int_value="past.no_fees"
        />
        <ulu-parking-row
          :title="$t('globals.fees_value')"
          :loading="loading.past"
          :price_value="past.total_fees_value"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import "vue-awesome/icons/spinner";
import "vue-awesome/icons/sync-alt";

export default {
  components: {
    Icon: () => import("vue-awesome/components/Icon.vue"),
    "ulu-parking-row": () =>
      import("@/components/dashboard/parkings/ParkingRow.vue")
  },
  props: {
    currentRange: Array,
    pastRange: Array
  },
  data() {
    return {
      tabIndex: 2,
      current: {
        no_parkings: 0,
        total_parking_costs_no_fees: 0,
        no_fees: 0,
        total_fees_value: 0
      },
      past: {
        no_parkings: 0,
        total_parking_costs_no_fees: 0,
        no_fees: 0,
        total_fees_value: 0
      },
      loading: {
        current: false,
        past: false
      }
    };
  },
  methods: {
    ...mapActions("stats", ["fetchParkingStatsForRange"]),
    fetchParkingsStats() {
      this.loading.current = true;
      this.loading.past = true;

      this.fetchParkingStatsForRange({ range: this.pastRange })
        .then(res => {
          this.past.no_parkings = res.parkingStatsForPeriod[0];
          this.past.total_parking_costs_no_fees = res.parkingStatsForPeriod[1];
          this.past.no_fees = res.parkingStatsForPeriod[2];
          this.past.total_fees_value = res.parkingStatsForPeriod[3];
        })
        .finally(() => {
          this.loading.past = false;
        });

      this.fetchParkingStatsForRange({ range: this.currentRange })
        .then(res => {
          this.current.no_parkings = res.parkingStatsForPeriod[0];
          this.current.total_parking_costs_no_fees =
            res.parkingStatsForPeriod[1];
          this.current.no_fees = res.parkingStatsForPeriod[2];
          this.current.total_fees_value = res.parkingStatsForPeriod[3];
        })
        .finally(() => {
          this.loading.current = false;
        });
    },
    fetchData() {
      this.fetchParkingsStats();
    }
  },
  computed: {
    ...mapGetters(["getUserSystem", "getDefConf", "getGraphQlUrl"]),
    isLoading() {
      return this.loading.current || this.loading.past;
    }
  },
  watch: {
    getUserSystem: function() {
      this.fetchData();
    }
  },
  mounted() {
    this.fetchData();
  }
};
</script>
